export default {
  title: 'Button CTA'
}

const Template = args => `
  <cradlepoint-button-cta
    text-color="${args.textColor}"
    text-color-hover="${args.textColorHover}"
    background-color="${args.backgroundColor}"
    background-color-hover="${args.backgroundColorHover}"
    border-color="${args.borderColor}"
    font-size="${args.fontSize ? args.fontSize : '14px'}"
    link="${args.link}"
  >
    ${args.content}
  </cradlepoint-button-cta>
`;

export const AllColors = () => `
  <cradlepoint-container
    columns="repeat(4, 1fr)"
    gap="2rem"
    style="padding:5rem 0;"
  >
    <cradlepoint-button-cta
      text-color="white"
      text-color-hover="var(--cwc-color-primary, #FFAD00)"
      background-color="var(--cwc-color-primary, #FFAD00)"
      background-color-hover="white"
    >
      Sunrise <i class="fa-solid fa-angle-right"></i>
    </cradlepoint-button-cta>
    <cradlepoint-button-cta>
      Charcoal <i class="fa-solid fa-angle-right"></i>
    </cradlepoint-button-cta>
    <cradlepoint-button-cta
      text-color="white"
      text-color-hover="var(--cwc-color-accent-b, #008EAA)"
      background-color="var(--cwc-color-accent-b, #008EAA)"
      background-color-hover="white"
    >
      River <i class="fa-solid fa-angle-right"></i>
    </cradlepoint-button-cta>
    <cradlepoint-button-cta
      text-color="white"
      text-color-hover="var(--cwc-color-accent-c, #0057B8)"
      background-color="var(--cwc-color-accent-c, #0057B8)"
      background-color-hover="white"
    >
      Boise Blue <i class="fa-solid fa-angle-right"></i>
    </cradlepoint-button-cta>
    <cradlepoint-button-cta
      text-color="var(--cwc-color-primary, #FFAD00)"
      text-color-hover="#fff"
      background-color="white"
      background-color-hover="var(--cwc-color-primary, #FFAD00)"
      border-color="var(--cwc-color-primary, #FFAD00)"
    >
      Sunrise Reverse <i class="fa-solid fa-angle-right"></i>
    </cradlepoint-button-cta>
    <cradlepoint-button-cta
      text-color="var(--cwc-color-secondary, #333F48)"
      text-color-hover="#fff"
      background-color="white"
      background-color-hover="var(--cwc-color-secondary, #333F48)"
      border-color="var(--cwc-color-secondary, #333F48)"
    >
      Charcoal Reverse <i class="fa-solid fa-angle-right"></i>
    </cradlepoint-button-cta>
    <cradlepoint-button-cta
      text-color="var(--cwc-color-accent-b, #008EAA)"
      text-color-hover="white"
      background-color="white"
      background-color-hover="var(--cwc-color-accent-b, #008EAA)"
      border-color="var(--cwc-color-accent-b, #008EAA)"
    >
      River Reverse <i class="fa-solid fa-angle-right"></i>
    </cradlepoint-button-cta>
    <cradlepoint-button-cta
      text-color="var(--cwc-color-accent-c, #0057B8)"
      text-color-hover="white"
      background-color="white"
      background-color-hover="var(--cwc-color-accent-c, #0057B8)"
      border-color="var(--cwc-color-accent-c, #0057B8)"
    >
      Boise Blue Reverse <i class="fa-solid fa-angle-right"></i>
    </cradlepoint-button-cta>
    <cradlepoint-button-cta
      text-color="white"
      text-color-hover="var(--cwc-color-accent-d, #C1C6C8)"
      background-color="var(--cwc-color-accent-d, #C1C6C8)"
    >
      Frost <i class="fa-solid fa-angle-right"></i>
    </cradlepoint-button-cta>
    <cradlepoint-button-cta
      text-color="white"
      text-color-hover="var(--cwc-color-accent-a, #009A44)"
      background-color="var(--cwc-color-accent-a, #009A44)"
      background-color-hover="white"
    >
      Treetop <i class="fa-solid fa-angle-right"></i>
    </cradlepoint-button-cta>
    <cradlepoint-button-cta
      text-color="white"
      text-color-hover="var(--cwc-color-red, #ff3232)"
      background-color="var(--cwc-color-red, #ff3232)"
      background-color-hover="white"
    >
      Red <i class="fa-solid fa-angle-right"></i>
    </cradlepoint-button-cta>
    <br />
    <cradlepoint-button-cta
      text-color="var(--cwc-color-accent-d, #C1C6C8)"
      text-color-hover="white"
      background-color="white"
      background-color-hover="var(--cwc-color-accent-d, #C1C6C8)"
      border-color="var(--cwc-color-accent-d, #C1C6C8)"
    >
      Frost Reverse <i class="fa-solid fa-angle-right"></i>
    </cradlepoint-button-cta>
    <cradlepoint-button-cta
      text-color="var(--cwc-color-accent-a, #009A44)"
      text-color-hover="white"
      background-color="white"
      background-color-hover="var(--cwc-color-accent-a, #009A44)"
      border-color="var(--cwc-color-accent-a, #009A44)"
    >
      Treetop Reverse <i class="fa-solid fa-angle-right"></i>
    </cradlepoint-button-cta>
    <cradlepoint-button-cta
      text-color="var(--cwc-color-red, #ff3232)"
      text-color-hover="white"
      background-color="white"
      background-color-hover="var(--cwc-color-red, #ff3232)"
      border-color="var(--cwc-color-red, #ff3232)"
    >
      Red Reverse <i class="fa-solid fa-angle-right"></i>
    </cradlepoint-button-cta>
  </cradlepoint-container>
`;

export const Default = Template.bind({});
export const DefaultReverse = Template.bind({});
export const Sunrise = Template.bind({});
export const SunriseReverse = Template.bind({});
export const River = Template.bind({});
export const RiverReverse = Template.bind({});
export const Treetop = Template.bind({});
export const TreetopReverse = Template.bind({});

Default.args = {
  textColor: 'white',
  backgroundColor: 'var(--cwc-color-secondary, #333F48)',
  textColorHover: 'var(--cwc-color-secondary, #333F48)',
  backgroundColorHover: 'white',
  borderColor: 'var(--cwc-color-secondary, #333F48)',
  fontSize: '',
  link: '#',
  content: `Default <i class="fa-solid fa-angle-right"></i>`
}

DefaultReverse.args = {
  textColor: 'var(--cwc-color-secondary, #333F48)',
  backgroundColor: 'white',
  textColorHover: 'white',
  backgroundColorHover: 'var(--cwc-color-secondary, #333F48)',
  borderColor: 'var(--cwc-color-secondary, #333F48)',
  fontSize: '',
  link: '#',
  content: `Default Reverse <i class="fa-solid fa-angle-right"></i>`
}

Sunrise.args = {
  textColor: 'white',
  backgroundColor: 'var(--cwc-color-primary, #FFAD00)',
  textColorHover: 'var(--cwc-color-primary, #FFAD00)',
  backgroundColorHover: 'white',
  borderColor: 'var(--cwc-color-primary, #FFAD00)',
  fontSize: '',
  link: '#',
  content: `Sunrise <i class="fa-solid fa-angle-right"></i>`
}

SunriseReverse.args = {
  textColor: 'var(--cwc-color-primary, #FFAD00)',
  backgroundColor: 'white',
  textColorHover: 'white',
  backgroundColorHover: 'var(--cwc-color-primary, #FFAD00)',
  borderColor: 'var(--cwc-color-primary, #FFAD00)',
  fontSize: '',
  link: '#',
  content: `Sunrise Reverse <i class="fa-solid fa-angle-right"></i>`
}

River.args = {
  textColor: 'white',
  backgroundColor: 'var(--cwc-color-accent-b, #008EAA)',
  textColorHover: 'var(--cwc-color-accent-b, #008EAA)',
  backgroundColorHover: 'white',
  borderColor: 'var(--cwc-color-accent-b, #008EAA)',
  fontSize: '',
  link: '#',
  content: `River <i class="fa-solid fa-angle-right"></i>`
}

RiverReverse.args = {
  textColor: 'var(--cwc-color-accent-b, #008EAA)',
  backgroundColor: 'white',
  textColorHover: 'white',
  backgroundColorHover: 'var(--cwc-color-accent-b, #008EAA)',
  borderColor: 'var(--cwc-color-accent-b, #008EAA)',
  fontSize: '',
  link: '#',
  content: `River Reverse <i class="fa-solid fa-angle-right"></i>`
}

Treetop.args = {
  textColor: 'white',
  backgroundColor: 'var(--cwc-color-accent-a, #009A44)',
  textColorHover: 'var(--cwc-color-accent-a, #009A44)',
  backgroundColorHover: 'white',
  borderColor: 'var(--cwc-color-accent-a, #009A44)',
  fontSize: '',
  link: '#',
  content: `Treetop <i class="fa-solid fa-angle-right"></i>`
}

TreetopReverse.args = {
  textColor: 'var(--cwc-color-accent-a, #009A44)',
  backgroundColor: 'white',
  textColorHover: 'white',
  backgroundColorHover: 'var(--cwc-color-accent-a, #009A44)',
  borderColor: 'var(--cwc-color-accent-a, #009A44)',
  fontSize: '',
  link: '#',
  content: `Treetop Reverse <i class="fa-solid fa-angle-right"></i>`
}
